import { useState, useEffect } from 'react';
import axios from 'axios';

export const useBrands = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await axios.get('brands');
        setBrands(res.data.data.map(brand => ({ id: brand.id, name: brand.name })));
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchBrands();
  }, []);

  return { brands, loading, error };
};
